import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { TipoUsuario } from 'app/entity/enumeraveis';
import { SelectItem } from 'primeng/primeng';
import { BaseCrudComponent } from "../../base";
import { ValidCpfORCnpj, requiredMinLength, validarSenha } from '../../util/custom.validators';
@Component({
    selector: 'usuario-crud',
    templateUrl: 'usuario-crud.component.html'
})

export class CrudUsuarioComponent extends BaseCrudComponent {
    controllerName = 'usuario';
    selectedValue: number;

    unidadesOptions: SelectItem[] = [];
    unidadeSelecionada: string[] = [];
    lotacoesOptions: SelectItem[] = [];
    usuarioOptions: SelectItem[] = [];
    historicoPermissoes: any;
    isLoaded: boolean = false;

    customValidation = true;

    tipoUsuarioId: number = TipoUsuario.Externo;

    filtro = this.formBuilder.group({
        possui: [null],
        query: [null],
        tipo: [null]
    });

    cadastro = this.formBuilder.group({
        nome: [null, [Validators.required]],
        cpf: [null, [Validators.required, ValidCpfORCnpj, requiredMinLength(11)]],
        email: [null, [Validators.required]],
        id_situacao: [1],
        senha: [null, [Validators.required, validarSenha]],
        confirmar: [null, [Validators.required, Validators.minLength(6)]],
        tipo: [null],
        usuario_lotacao_perfil: [null, [Validators.required]],
        id: [null]
    });

    init() {
        let tipoUsuario = this.activatedRoute.snapshot.data.tipo;
        if (tipoUsuario) {
            this.tipoUsuarioId = tipoUsuario;
        }

        super.init();
        super.afterLoad();

        this.service.ListarTodos('lotacao').subscribe(
            data => {
                this.unidadesOptions = data;
            }
        );

        this.service.ObterTodos('usuario/comboUsuario').subscribe(
            data => {
                this.usuarioOptions = data
            }
        );

        this.cadastro.get("id").valueChanges.subscribe(x => {
            if (x != null && this.isLoaded == false) {
                this.isLoaded = true;
                this.service.ObterTodos(`usuarioLotacaoPerfil/ListarPermissoesPorUsuario/${x}`).subscribe(retorno => {
                    this.historicoPermissoes = retorno;
                });
            }
        });
    }

    afterLoad() {
        let listaLotacoes: any = []
        let lotacao: any = [];
        if (this.acao != "cadastrar") {
            this.cadastro.get('senha').clearValidators();
            this.cadastro.get('confirmar').clearValidators();
            this.cadastro.get('senha').updateValueAndValidity();
            this.cadastro.get('confirmar').updateValueAndValidity();
            this.cadastro.get("senha").setValue(this.obj.senha);
            this.cadastro.get("confirmar").setValue(this.obj.senha);
            this.cadastro.enable();
            this.cadastro.patchValue(this.obj);

            listaLotacoes.push(this.obj.usuario_lotacao_perfil.filter(obj => obj.data_exclusao_unidades === null && obj.id_status == 2).map(y => y.id_lotacao));
            listaLotacoes[0].forEach(x => { if (lotacao.find(y => y === x)) { } else { lotacao.push(x) } });
            this.cadastro.get("usuario_lotacao_perfil").setValue(lotacao);
        }
    }

    /**
     * Sobrescrita do metodo emitValidation, esse metodo realiza a multipla validação dos formularios e listas usados na funcionalidade. 
     */
    emitValidation(isInit: any) {
        if (!isInit) {
            let validateConfirmarSenha = this.cadastro.value.senha == this.cadastro.value.confirmar ? true : false;
            if (validateConfirmarSenha && this.cadastro.valid)
                this.multiValidator.isValid = true;
            else {
                this.multiValidator.isValid = false;
                let validateForm = this.formBuilder.group({});
                if (!this.cadastro.valid)
                    validateForm.addControl('cadastro', this.cadastro);
                if (!validateConfirmarSenha)
                    super.showMsg('error', 'Mensagem de Erro', 'Senhas não conferem.');

                this.multiValidator.cadastro = validateForm;
            }
        }
    }

    finalizar(event: any) {
        var dados: any = Object.assign({}, this.cadastro.value);
        if (this.acao == 'cadastrar') {
            dados.usuario_lotacao_perfil = this.cadastro.get('usuario_lotacao_perfil').value.map(val => {
                return {
                    id_lotacao: val
                }
            });
        }
        else {
            dados.usuario_lotacao_perfil = this.cadastro.get('usuario_lotacao_perfil').value.map(val => {
                return {
                    id: 0,
                    id_usuario: this.cadastro.get("id").value,
                    id_lotacao: val
                }
            });
        }       

        dados.tipo = this.tipoUsuarioId;
        
        dados.cpf = this.limpaCaracterEspecial(this.cadastro.get("cpf").value);

        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, o usuário será ${this.acao == 'cadastrar' ? 'salva' : 'atualizada'} na base de dados.
            Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.acao === 'cadastrar' ?
                    this.service.Adicionar(this.controllerName, dados).subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro salvo com sucesso.");
                            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false)
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this.showMsg('warn', 'Mensagem de Erro', `Erro ao gravar. ${err._body}`)
                        }
                    ) :
                    this.service.Atualizar(this.controllerName, dados).subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro atualizado com sucesso.");
                            this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        }, err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false)
                            super.showMsg('warn', 'Mensagem de Erro', `Erro ao atualizar. ${err._body}`)
                        }
                    );
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/usuario/crud/usuario-crud.component.ts